import { useState, useCallback } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Frame, Navigation, TopBar } from '@shopify/polaris';

function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);

  const toggleMobileNavigationActive = useCallback(
    () => setMobileNavigationActive((active) => !active),
    []
  );

  const navigationMarkup = (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            label: 'Vendor Management',
            onClick: () => navigate('/vendors'),
            selected: location.pathname === '/vendors'
          },
          {
            label: 'Manual Export',
            onClick: () => navigate('/manual-export'),
            selected: location.pathname === '/manual-export'
          },
          {
            label: 'Export History',
            onClick: () => navigate('/export-history'),
            selected: location.pathname === '/export-history'
          },
          {
            label: 'Settings',
            onClick: () => navigate('/settings'),
            selected: location.pathname === '/settings'
          }
        ]}
      />
    </Navigation>
  );

  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      onNavigationToggle={toggleMobileNavigationActive}
    />
  );

  return (
    <Frame
      topBar={topBarMarkup}
      navigation={navigationMarkup}
      showMobileNavigation={mobileNavigationActive}
      onNavigationDismiss={toggleMobileNavigationActive}
    >
      <Outlet />
    </Frame>
  );
}

export default AppLayout;
